import { Check, LayoutGrid, List, Rows3 } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export type Appearance = "grid" | "list";

type Props = {
  value: Appearance;
  onChange: (next: Appearance) => void;
};

/**
 * Matches the "Appearance" control in the Frame.io reference screenshot.
 * Same underlying grid/list toggle as ProjectsPage, just presented as a
 * labeled dropdown instead of a segmented button here — no thumbnail-size
 * options since we don't have real thumbnails to preview yet.
 */
export function AppearanceMenu({ value, onChange }: Props) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center gap-1.5 text-muted-foreground transition-colors hover:text-foreground">
          <Rows3 className="h-3.5 w-3.5" strokeWidth={1.75} />
          Appearance
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-44">
        <DropdownMenuLabel>Appearance</DropdownMenuLabel>
        <DropdownMenuItem onSelect={() => onChange("grid")}>
          <LayoutGrid />
          Grid
          {value === "grid" && <Check className="ml-auto h-3.5 w-3.5 text-primary" />}
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => onChange("list")}>
          <List />
          List
          {value === "list" && <Check className="ml-auto h-3.5 w-3.5 text-primary" />}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
